import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { CTAButton } from './CTAButton';
import { BonusCard } from './BonusCard';
import { PricingSection } from './PricingSection';
import { TestimonialSection } from './TestimonialSection';
import { FAQSection } from './FAQSection';
import { SocialProofPopup } from './SocialProofPopup';
import { ShieldCheckIcon } from 'lucide-react';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/87dYyEWwxvxDSawQQfbd23/WhatsApp_Image_2026-03-23_at_23.51.54.jpg';
const BONO1_IMAGE = 'https://cdn.magicpatterns.com/uploads/d4PzmaWrLxHejeqxESZKgN/mocap_bono_1-herrero_(2).png';
const BONO2_IMAGE = 'https://cdn.magicpatterns.com/uploads/6JUuUz4MEwVRVGKzxw5oGv/mocap_bono_2-herrero_(2).png';
const BONO3_IMAGE = 'https://cdn.magicpatterns.com/uploads/3J1797Ahhh6cuyuXT4YPXW/mocap_bono_3-_herrero.png';
const BONO4_IMAGE = 'https://cdn.magicpatterns.com/uploads/88xYpsvRiAjU8zxtm7GwyT/mocap_bono_4-herrero.png';
function scrollToCompra() {
  const el = document.getElementById('compra');
  if (el) el.scrollIntoView({
    behavior: 'smooth'
  });
}
export function LandingPage() {
  return <div className="w-full min-h-screen bg-white" data-id="element-33">
      <CountdownTimer data-id="element-34" />
      <SocialProofPopup data-id="element-35" />

      {/* Spacer for fixed countdown bar */}
      <div className="h-12 md:h-14" aria-hidden="true" data-id="element-36" />

      <main data-id="element-37">
        {/* ===== SECTION 1: HERO ===== */}
        <section className="bg-gradient-to-b from-gray-900 to-gray-800 py-10 md:py-16 px-4" data-id="element-38">
          <div className="max-w-4xl mx-auto text-center" data-id="element-39">
            <p className="text-base md:text-xl text-gray-300 mb-3" data-id="element-40">
              🛠️ Para personas que quieren ganar más con su taller sin
              improvisar
            </p>

            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-extrabold text-white mb-4 leading-[1.1]" data-id="element-41">
              🔩 Mega Pack
              <br data-id="element-42" />
              Maestro Herrero
            </h1>

            <p className="text-amber-400 font-bold text-lg md:text-xl mb-6" data-id="element-43">
              +1000 Planos Industriales Listos Para Fabricar
            </p>

            {/* HERO PRODUCT IMAGE */}
            <button onClick={scrollToCompra} className="cursor-pointer block mx-auto mb-8 max-w-sm md:max-w-3xl w-full" data-id="element-44">
              <div className="w-full aspect-[16/9] bg-gray-700 rounded-xl overflow-hidden shadow-2xl border-4 border-amber-500/50 hover:border-amber-500 transition-colors duration-300" data-id="element-45">
                <img src={HERO_IMAGE} alt="Mega Pack Maestro Herrero - Más de 1000 proyectos industriales rentables listos para usar" className="w-full h-full object-cover" width={1200} height={675} sizes="(max-width: 768px) 85vw, 768px" fetchPriority="high" data-id="element-46" />
              </div>
            </button>

            <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto mb-8 leading-relaxed" data-id="element-47">
              Todo lo que necesitás para fabricar proyectos que se venden,
              ahorrar tiempo y dejar de adivinar qué hacer.
              <br data-id="element-48" />
              <strong className="text-white" data-id="element-49">
                Claro, práctico y listo para usar. Sin vueltas. Sin prueba y
                error.
              </strong>
            </p>

            <div className="max-w-xl mx-auto mb-4" data-id="element-50">
              <CTAButton href="#compra" data-id="element-51">👉 SÍ, QUIERO ACCEDER AHORA</CTAButton>
            </div>
            <p className="text-green-400 font-semibold text-sm md:text-base" data-id="element-52">
              ✅ Garantía de satisfacción de 7 días
            </p>
          </div>
        </section>

        {/* ===== SECTION 2: PROBLEM AGITATION ===== */}
        <section className="bg-gray-50 py-16 md:py-20 px-4" data-id="element-53">
          <div className="max-w-3xl mx-auto" data-id="element-54">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-gray-900 text-center mb-8 leading-tight" data-id="element-55">
              Si tenés un taller o sabés de herrería, dejame hacerte una
              pregunta honesta
            </h2>

            <p className="text-xl md:text-2xl text-gray-800 text-center font-semibold mb-8" data-id="element-56">
              ¿Te pasa que trabajás mucho… pero sentís que podrías estar ganando
              más?
            </p>

            <div className="space-y-4 text-gray-700 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-57">
              <p data-id="element-58">No porque te falte capacidad.</p>
              <p data-id="element-59">No porque no tengas herramientas.</p>
              <p className="font-bold text-gray-900" data-id="element-60">
                Sino porque nadie te enseñó qué proyectos realmente dejan plata.
              </p>

              <div className="py-4 space-y-2" data-id="element-61">
                <p data-id="element-62">Hacés trabajos chicos…</p>
                <p data-id="element-63">Perdés tiempo calculando…</p>
                <p data-id="element-64">Desperdiciás material…</p>
              </div>

              <p data-id="element-65">Y ves a otros herreros crecer mientras vos seguís igual.</p>

              <p className="text-xl font-semibold text-gray-900 italic mt-6 bg-amber-50 border-l-4 border-amber-500 p-4 rounded-r-lg" data-id="element-66">
                Y te queda esa sensación:
                <br data-id="element-67" />
                "Sé que podría estar haciendo algo mejor…"
              </p>
            </div>
          </div>
        </section>

        {/* ===== SECTION 3: DEEPER PROBLEM (BLACK BG) ===== */}
        <section className="bg-gray-900 py-16 md:py-20 px-4" data-id="element-68">
          <div className="max-w-3xl mx-auto" data-id="element-69">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white text-center mb-6" data-id="element-70">
              Trabajar en un taller no debería sentirse así
            </h2>

            <p className="text-gray-400 text-center text-lg mb-4" data-id="element-71">
              El problema que nadie dice en voz alta es este:
            </p>

            <p className="text-amber-400 text-center text-xl md:text-2xl font-bold mb-10" data-id="element-72">
              👉 No ganás menos por falta de trabajo, sino por falta de
              dirección.
            </p>

            <p className="text-gray-300 text-center text-lg mb-8" data-id="element-73">
              Si trabajás en herrería, esto seguro te resulta familiar:
            </p>

            <div className="space-y-4 max-w-xl mx-auto mb-10" data-id="element-74">
              <div className="flex items-start gap-3" data-id="element-75">
                <span className="text-red-400 text-xl mt-0.5" data-id="element-76">●</span>
                <p className="text-gray-200 text-lg" data-id="element-77">
                  No sabés qué proyectos son realmente rentables
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-78">
                <span className="text-red-400 text-xl mt-0.5" data-id="element-79">●</span>
                <p className="text-gray-200 text-lg" data-id="element-80">
                  Improvisás medidas o diseños
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-81">
                <span className="text-red-400 text-xl mt-0.5" data-id="element-82">●</span>
                <p className="text-gray-200 text-lg" data-id="element-83">
                  Perdés tiempo corrigiendo errores
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-84">
                <span className="text-red-400 text-xl mt-0.5" data-id="element-85">●</span>
                <p className="text-gray-200 text-lg" data-id="element-86">
                  Hacés trabajos chicos mal pagos
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-87">
                <span className="text-red-400 text-xl mt-0.5" data-id="element-88">●</span>
                <p className="text-gray-200 text-lg" data-id="element-89">
                  Sentís que podrías hacer más… pero no sabés por dónde empezar
                </p>
              </div>
            </div>

            <p className="text-gray-400 text-center text-lg italic" data-id="element-90">
              Lo peor no es el esfuerzo.
              <br data-id="element-91" />
              <span className="text-white font-semibold" data-id="element-92">
                Es sentir que no estás aprovechando todo tu potencial.
              </span>
            </p>
          </div>
        </section>

        {/* ===== SECTION 4: SOLUTION REVEAL ===== */}
        <section className="bg-white py-16 md:py-20 px-4" data-id="element-93">
          <div className="max-w-4xl mx-auto text-center" data-id="element-94">
            <span className="inline-block bg-green-500 text-white font-heading font-bold text-sm uppercase tracking-widest px-6 py-2 rounded-full mb-6" data-id="element-95">
              ✅ LA SOLUCIÓN
            </span>

            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6" data-id="element-96">
              Mega Pack Maestro Herrero
            </h2>

            <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-97">
              Un sistema completo, claro y paso a paso, diseñado para que puedas
              fabricar proyectos que ya se venden, trabajar con precisión y
              aumentar tus ingresos sin improvisar.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto mb-10" data-id="element-98">
              <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6" data-id="element-99">
                <span className="text-4xl mb-3 block" data-id="element-100">📂</span>
                <p className="font-heading font-bold text-gray-900 text-lg" data-id="element-101">
                  Abrís los planos
                </p>
              </div>
              <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6" data-id="element-102">
                <span className="text-4xl mb-3 block" data-id="element-103">👀</span>
                <p className="font-heading font-bold text-gray-900 text-lg" data-id="element-104">
                  Elegís el proyecto
                </p>
              </div>
              <div className="bg-amber-50 border-2 border-amber-200 rounded-xl p-6" data-id="element-105">
                <span className="text-4xl mb-3 block" data-id="element-106">✍️</span>
                <p className="font-heading font-bold text-gray-900 text-lg" data-id="element-107">
                  Fabricás con medidas exactas
                </p>
              </div>
            </div>

            <p className="text-gray-600 text-lg" data-id="element-108">
              Sin adivinar. Sin perder material. Sin errores innecesarios.
            </p>
          </div>
        </section>

        {/* ===== SECTION 5: WHAT'S INCLUDED ===== */}
        <section className="bg-gray-50 py-16 md:py-20 px-4" data-id="element-109">
          <div className="max-w-4xl mx-auto" data-id="element-110">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-111">
              📘 ¿Qué incluye exactamente el Mega Pack?
            </h2>

            <div className="space-y-6" data-id="element-112">
              <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-113">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-114">
                  🔹 +1000 Planos de Proyectos Industriales
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-115">
                  Proyectos reales, probados y listos para fabricar y vender.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-116">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-117">
                  🔹 Planos con Medidas Exactas
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-118">
                  Cortes profesionales listos para replicar sin errores.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-119">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-120">
                  🔹 Proyectos de Alto Ticket
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-121">
                  Muebles, estructuras y trabajos que dejan mejor margen.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-122">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-123">
                  🔹 Sistema para Elegir Qué Fabricar
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-124">
                  Dejá de improvisar y empezá a trabajar con lógica.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-125">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-126">
                  🔹 Videos Explicativos
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-127">
                  Tutoriales paso a paso en video para que veas cómo se fabrica
                  cada proyecto. Aprendé técnicas, trucos y detalles que solo se
                  entienden viéndolos.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border border-gray-100" data-id="element-128">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-gray-900 mb-2" data-id="element-129">
                  🔹 Acceso Inmediato
                </h3>
                <p className="text-gray-600 text-lg" data-id="element-130">
                  Todo organizado para que encuentres rápido lo que necesitás.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ===== SECTION 6: BEFORE vs AFTER (BLACK BG) ===== */}
        <section className="bg-gray-900 py-16 md:py-20 px-4" data-id="element-131">
          <div className="max-w-4xl mx-auto" data-id="element-132">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-133">
              🔄 Antes vs Después
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-134">
              {/* ANTES */}
              <div className="bg-red-950/40 border-2 border-red-500/30 rounded-xl p-6 md:p-8" data-id="element-135">
                <h3 className="font-heading text-2xl font-bold text-red-400 mb-6 text-center" data-id="element-136">
                  ❌ Antes del Mega Pack
                </h3>
                <div className="space-y-4" data-id="element-137">
                  <div className="flex items-start gap-3" data-id="element-138">
                    <span className="text-red-400 mt-0.5" data-id="element-139">●</span>
                    <p className="text-gray-300" data-id="element-140">Trabajos mal pagos</p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-141">
                    <span className="text-red-400 mt-0.5" data-id="element-142">●</span>
                    <p className="text-gray-300" data-id="element-143">Pérdida de material</p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-144">
                    <span className="text-red-400 mt-0.5" data-id="element-145">●</span>
                    <p className="text-gray-300" data-id="element-146">Tiempo desperdiciado</p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-147">
                    <span className="text-red-400 mt-0.5" data-id="element-148">●</span>
                    <p className="text-gray-300" data-id="element-149">Dudas constantes</p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-150">
                    <span className="text-red-400 mt-0.5" data-id="element-151">●</span>
                    <p className="text-gray-300" data-id="element-152">Improvisación</p>
                  </div>
                </div>
              </div>

              {/* DESPUÉS */}
              <div className="bg-green-950/40 border-2 border-green-500/30 rounded-xl p-6 md:p-8" data-id="element-153">
                <h3 className="font-heading text-2xl font-bold text-green-400 mb-6 text-center" data-id="element-154">
                  ✅ Después del Mega Pack
                </h3>
                <div className="space-y-4" data-id="element-155">
                  <div className="flex items-start gap-3" data-id="element-156">
                    <span className="text-green-400 mt-0.5" data-id="element-157">●</span>
                    <p className="text-gray-300" data-id="element-158">
                      Proyectos más grandes y rentables
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-159">
                    <span className="text-green-400 mt-0.5" data-id="element-160">●</span>
                    <p className="text-gray-300" data-id="element-161">Trabajo con precisión</p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-162">
                    <span className="text-green-400 mt-0.5" data-id="element-163">●</span>
                    <p className="text-gray-300" data-id="element-164">Menos errores y desperdicio</p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-165">
                    <span className="text-green-400 mt-0.5" data-id="element-166">●</span>
                    <p className="text-gray-300" data-id="element-167">Claridad total</p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-168">
                    <span className="text-green-400 mt-0.5" data-id="element-169">●</span>
                    <p className="text-gray-300" data-id="element-170">Más ingresos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== STRATEGIC CTA BETWEEN BEFORE/AFTER AND BONUSES ===== */}
        <section className="bg-amber-500 py-10 md:py-12 px-4" data-id="element-171">
          <div className="max-w-2xl mx-auto text-center" data-id="element-172">
            <CTAButton href="#compra" variant="primary" className="bg-gray-900 hover:bg-black text-white" data-id="element-173">
              🔥 QUIERO TRANSFORMAR MI TALLER AHORA
            </CTAButton>
          </div>
        </section>

        {/* ===== SECTION 7: BONUSES ===== */}
        <section className="bg-white py-16 md:py-20 px-4" data-id="element-174">
          <div className="max-w-5xl mx-auto" data-id="element-175">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-center text-gray-900 mb-4" data-id="element-176">
              🎁 BONUS ESPECIALES – GRATIS HOY
            </h2>
            <p className="text-center text-gray-600 text-lg mb-12" data-id="element-177">
              Estos bonos son{' '}
              <span className="font-bold text-green-600" data-id="element-178">
                GRATIS por el día de hoy
              </span>{' '}
              con tu compra del Mega Pack
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-179">
              <BonusCard number={1} title="Herrería Artística" description="Diseños decorativos de alto valor que te diferencian del resto." imageUrl={BONO1_IMAGE} data-id="element-180" />
              <BonusCard number={2} title="Carpintería que Vende" description="Combiná hierro + madera y accedé a productos de alto ticket." imageUrl={BONO2_IMAGE} data-id="element-181" />
              <BonusCard number={3} title="Tornería desde Cero" description="Sumá nuevas habilidades y ampliá tu taller." imageUrl={BONO3_IMAGE} data-id="element-182" />
              <BonusCard number={4} title="Guía de Presupuesto + Ventas por WhatsApp" description="Aprendé a cobrar bien y cerrar más trabajos." imageUrl={BONO4_IMAGE} data-id="element-183" />
              <BonusCard number={5} title="Soldadura desde Cero" description="Dominá las bases y mejorá la calidad de tus trabajos." imageUrl="https://cdn.magicpatterns.com/uploads/fXTaH3MAXvCMrGkfWUbveV/mocap_bono_5-herrero.png" data-id="element-184" />
              <BonusCard number={6} title="Planos Premium Máquinas Gym y Trailer" description="Entrá en nichos de alto ticket y baja competencia." imageUrl="https://cdn.magicpatterns.com/uploads/voAkSEHcTCUJEfompgB8qp/mocap_bono_6-herrero.png" data-id="element-185" />
            </div>
          </div>
        </section>

        {/* ===== SECTION 8: PRICING ===== */}
        <PricingSection data-id="element-186" />

        {/* ===== SECTION 9: GUARANTEE ===== */}
        <section className="bg-gray-50 py-16 md:py-20 px-4" data-id="element-187">
          <div className="max-w-2xl mx-auto text-center" data-id="element-188">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-gray-200" data-id="element-189">
              <ShieldCheckIcon className="w-16 h-16 text-green-500 mx-auto mb-6" data-id="element-190" />
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-191">
                🔒 Garantía sin riesgo
              </h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-4" data-id="element-192">
                Probalo durante 7 días. Si no te ayuda a fabricar mejor, ahorrar
                tiempo y ganar más, te devolvemos el 100% del dinero.
              </p>
              <p className="font-bold text-gray-900 text-xl" data-id="element-193">Sin preguntas.</p>
            </div>
          </div>
        </section>

        {/* ===== SECTION 10: TESTIMONIALS ===== */}
        <TestimonialSection data-id="element-194" />

        {/* ===== SECTION 11: FAQ ===== */}
        <FAQSection data-id="element-195" />

        {/* ===== SECTION 12: FINAL CTA (BLACK BG) ===== */}
        <section className="bg-gray-900 py-16 md:py-20 px-4" data-id="element-196">
          <div className="max-w-3xl mx-auto text-center" data-id="element-197">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6" data-id="element-198">
              Trabajar mejor y ganar más es posible
            </h2>

            <p className="text-gray-300 text-lg mb-2" data-id="element-199">
              No necesitás trabajar más horas.
            </p>
            <p className="text-amber-400 text-xl font-bold mb-10" data-id="element-200">
              Necesitás trabajar en lo correcto.
            </p>

            <div className="max-w-xl mx-auto mb-8" data-id="element-201">
              <CTAButton href="#compra" data-id="element-202">
                👉 Accedé ahora al Mega Pack Maestro Herrero
              </CTAButton>
            </div>

            <p className="text-gray-400 text-lg" data-id="element-203">
              Porque no se trata de hacer más…
              <br data-id="element-204" />
              <span className="text-amber-400 font-semibold" data-id="element-205">
                sino de hacer lo que realmente se vende. 🔥🛠️
              </span>
            </p>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-black py-8 px-4 text-center" data-id="element-206">
        <p className="text-gray-500 text-sm" data-id="element-207">
          © {new Date().getFullYear()} Mega Pack Maestro Herrero. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}